<template>
  <div class="header layou-box">
    <div class="header left">
      <img class="logo" src="@/assets/logo1.png" alt="" />
      <header-menu></header-menu>
    </div>
    <div class="right">
      <el-button
        v-if="!user.isLogin"
        type="primary"
        @click="showLogin = true"
        size="mini"
        >登录</el-button
      >
      <!-- 登录 -->
      <span v-else>
        <el-dropdown @command="handlerCommand">
          <span class="el-dropdown-link" style="cursor: pointer">
            <img class="avatar" src="@/assets/common/avatar.png" />
            {{ user.userInfo.nickName || user.userInfo.userName
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <el-dropdown-item command="logout">
              <div>
                <img class="icon" src="@/assets/common/exit.png" alt="" />
                <img
                  class="icon iconActive"
                  src="@/assets/common/exitActive.png"
                  alt=""
                />
                <span>退出登录</span>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="updatePassword">
              <div>
                <img class="icon" src="@/assets/common/edit.png" alt="" />
                <img
                  class="icon iconActive"
                  src="@/assets/common/editActive.png"
                  alt=""
                />
                <span>修改密码</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
    </div>
    <!-- 登录窗口 -->
    <login-vue :visible.sync="showLogin"></login-vue>
    <!-- 修改密码弹窗 -->
    <edit-password-vue :visible.sync="showPassword" ></edit-password-vue>
  </div>
</template>

<script>
import LoginVue from "@/components/Login/Login.vue";
import HeaderMenu from "./HeaderMenu.vue";
import EditPasswordVue from '@/components/EditPassword/EditPassword.vue';
import { mapState } from "vuex";
import { getToken } from '@/utils/token';
export default {
  name: "HeaderVue",
  components: {
    HeaderMenu,
    EditPasswordVue,
    LoginVue,
  },
  data() {
    return {
      showLogin: false,
      showPassword: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
    }),
  },
  created() {
    // this.$bus.$on("login", () => {
    //   console.log('收到---------',)
    //   this.showLogin = true;
    // });
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        if(!getToken() && this.$route.meta.requireAuth) {
          this.showLogin = true;
        }
      }
    }
  },
  methods: {
    handlerCommand(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "updatePassword":
          this.showPassword = true
          break;
      }
    },
    logout() {
      this.$store.dispatch("logout");
    },
  },
};
</script>

<style lang="less" scoped >
.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    height: 39px;
    object-fit: contain;
    width: 262px;
    margin-right: 30px;
  }
  .avatar {
    width: 28px;
    height: 28px;
    vertical-align: middle;
    // margin-right: 10px;
  }
}
</style>